import {decorate, observable, action} from "mobx"

export class NavStore {
  brandId // this is brandId for breadcrumb navigation

  sideNavToggle = false

  locationGroupName

  currentPage

  previousPage

  setSideNavToggle(bool) {
    this.sideNavToggle = bool
  }

  setBrandId(id) {
    this.brandId = id
  }

  setLocationGroupName(name) {
    this.locationGroupName = name
  }

  setPreviousPage(page) {
    this.previousPage = page
  }

  setCurrentPage(page) {
    this.currentPage = page
  }
}

decorate(NavStore, {
  sideNavToggle: observable,
  setSideNavToggle: action,

  brandId: observable,
  setBrandId: action,

  locationGroupName: observable,
  setLocationGroupName: action,

  previousPage: observable,
  setPreviousPage: action,

  currentPage: observable,
  setCurrentPage: action,
})
